/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Skill_TitleInputs */

const en_mk_skill_title = /** @type {(inputs: Mk_Skill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-made agents per division, day one`)
};

const id_mk_skill_title = /** @type {(inputs: Mk_Skill_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen siap pakai per divisi, sejak hari pertama`)
};

/**
* | output |
* | --- |
* | "Ready-made agents per division, day one" |
*
* @param {Mk_Skill_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_skill_title = /** @type {((inputs?: Mk_Skill_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Skill_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_skill_title(inputs)
	return en_mk_skill_title(inputs)
});